const alertConfig = {
    position: 'top-end',
    icon: 'success',
    title: 'Data has been saved',
    showConfirmButton: false,
    timer: 1500
};

export default alertConfig;